import { ExchButtonStatus } from '@/types/exch-info';
import { CouponState } from '@tencent/wphk-act-base-types';

/** 券详情弹窗的按钮状态文案 */
export const DETAIL_DIALOG_BTN_TEXT = {
  [ExchButtonStatus.IsLocked]: '領取',
  [ExchButtonStatus.ToReceive]: '立即領取',
  [ExchButtonStatus.ToUse]: '去使用',
  [ExchButtonStatus.Hidden]: '',
  [ExchButtonStatus.IsLimit]: '領取',
};

/** 券面水印文案 */
export const COUPON_STAMP_TEXT = {
  [CouponState.received]: '已領取',
  [CouponState.used]: '已使用',
  [CouponState.expired]: '已過期',
};
